import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Z_INDEX from '@databases/layout/z-index';
import styled, { css } from 'styled-components';

import { TABLE_CLASSNAMES } from '../../../../constants';

export const selectButtonActiveStyle = css`
  background-color: ${token('color.background.accent.blue.subtler.pressed', colors.B200)};
  color: ${token('color.text.inverse', colors.N0)};
`;

export const selectButtonDeletionActiveStyle = css`
  background-color: ${token('color.background.accent.red.subtler.pressed', colors.R400)};
  color: ${token('color.text.inverse', colors.N0)};
`;

export const RowSelectButtonContainer = styled.td`
  position: sticky !important;
  z-index: ${Z_INDEX.ROW_SELECT_BUTTON};
  left: 0;
  border: none !important;

  .${TABLE_CLASSNAMES.SELECT_BUTTON} {
    position: absolute;
    top: calc(50% - 13.5px);
    left: -0.5px;
    width: max-content;
  }
`;

export const ColSelectButtonContainer = styled.div`
  position: absolute;
  z-index: ${Z_INDEX.COLUMN_SELECT_BUTTON};
  top: -9.5px;
  left: calc(50% - 12.5px);
`;

export const DragHandlerWrapper = styled.div<{
  isActive: boolean;
  isDeletionActive: boolean;
}>`
  ${({ isActive, isDeletionActive }) =>
    isActive &&
    css`
      &&& {
        ${isDeletionActive ? selectButtonDeletionActiveStyle : selectButtonActiveStyle};
        display: flex;
      }
    `}
`;
